import {LayoutTypes, useLayoutType} from "@/util-react/layout.tsx";
import {HeaderMobile} from "@/elements-react/catalog-layout/header/header-mobile.tsx";
import {HeaderDesktop} from "@/elements-react/catalog-layout/header/header-desktop.tsx";

export interface HeaderProps {
    countryElementRefCallback?: (element?: Element) => void;
    onCategoryClick?: (e: any) => void;
    onMenuClick?: (e: any) => void;
    simple?: boolean;
}
export const Header = (props: HeaderProps) => {
    const layoutType = useLayoutType();
    return layoutType.layoutType === LayoutTypes.TYPE_MOBILE ? <HeaderMobile {...props} /> : <HeaderDesktop {...props}  />;
}